import { createSlice } from '@reduxjs/toolkit';

export const selectedPageSlice = createSlice({
	name: 'selectPage',
	initialState: {
		value: 'default-1',
	},
	reducers: {
		selectPage: (state, action) => {
			state.value = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { selectPage } = selectedPageSlice.actions;
export const selectedPage = (state) => state.selectPage.value;
export default selectedPageSlice.reducer;
